const getters = {
  token: state => state.user.token,
  usuario: state => state.user.usuario,
  prontuario: state => state.user.prontuario
}

export default getters
